"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClinicReimbursement = void 0;
/* eslint-disable sort-keys */
require("ag-grid-community/dist/styles/ag-grid.css");
require("ag-grid-community/dist/styles/ag-theme-balham.css");
const ag_grid_react_1 = require("ag-grid-react");
const ui_1 = require("client/components/ui");
const store_1 = require("client/modules/reporting/store");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const no_data_found_1 = require("../no-data-found/no-data-found");
require("./clinic-reimbursement.less");
const clinic_reimbursement_header_1 = require("./components/clinic-reimbursement-header");
const number_formatter_1 = require("../claim-analytics/number-formatter");
let ClinicReimbursement = class ClinicReimbursement extends React.Component {
    constructor(props) {
        super(props);
        this.onButtonExport = () => {
            const params = {
                fileName: "Pharmacy_Reimbursement.csv"
            };
            this.storeData.gridApi.exportDataAsCsv(params);
        };
        this.storeData = {
            defaultColDef: {
                enablePivot: true,
                enableRowGroup: true,
                enableValue: true,
                sortable: true,
                resizable: true,
                filter: true,
                comparator: (a, b) => {
                    if (typeof a === "string") {
                        return a.localeCompare(b);
                    }
                    return a > b ? 1 : a < b ? -1 : 0;
                }
            },
            columnDefs: [
                {
                    headerName: "Pharmacy Name",
                    field: "Pharmacy Name",
                    cellRenderer: "agGroupCellRenderer"
                },
                {
                    headerName: "Billing Period",
                    field: "Billing Period",
                    filter: "agTextColumnFilter",
                    enableRowGroup: true
                },
                {
                    headerName: "Insurance Reimbursements",
                    field: "Total Amount Dispensed",
                    filter: "agTextColumnFilter",
                    type: "numericColumn",
                    cellRenderer: "numberFormatter",
                    aggFunc: "sum"
                },
                {
                    headerName: "Inventory Purchased",
                    field: "Total Inventory Purchased",
                    filter: "agTextColumnFilter",
                    type: "numericColumn",
                    cellRenderer: "numberFormatter",
                    aggFunc: "sum"
                },
                {
                    headerName: "Flat Rate Approval Processing Fee",
                    field: "Flat Fee Sum",
                    filter: "agTextColumnFilter",
                    type: "numericColumn",
                    cellRenderer: "numberFormatter",
                    aggFunc: "sum"
                },
                {
                    headerName: "Percentage Approval Processing Fee",
                    field: "Percent Fee Sum",
                    filter: "agTextColumnFilter",
                    type: "numericColumn",
                    cellRenderer: "numberFormatter",
                    aggFunc: "sum"
                },
                {
                    headerName: "Transaction Processing Fee",
                    field: "Transaction Fee",
                    filter: "agTextColumnFilter",
                    type: "numericColumn",
                    cellRenderer: "numberFormatter",
                    aggFunc: "sum"
                },
                {
                    headerName: "Insurance POS Fee",
                    field: "Total POS Fee",
                    filter: "agTextColumnFilter",
                    type: "numericColumn",
                    cellRenderer: "numberFormatter",
                    aggFunc: "sum"
                },
                {
                    headerName: "Insurance DIR Fee",
                    field: "Total DIR Fee",
                    filter: "agTextColumnFilter",
                    type: "numericColumn",
                    cellRenderer: "numberFormatter",
                    aggFunc: "sum"
                },
                {
                    headerName: "Carryover Balance",
                    field: "Carryover Balance",
                    filter: "agTextColumnFilter",
                    type: "numericColumn",
                    cellRenderer: "numberFormatter"
                },
                {
                    headerName: "Account Adjustments",
                    field: "Adjustments",
                    filter: "agTextColumnFilter",
                    type: "numericColumn",
                    cellRenderer: "numberFormatter",
                    aggFunc: "sum"
                },
                {
                    headerName: "Net Pharmacy Reimbursement Due",
                    field: "Net Clinic Reimbursement Due",
                    filter: "agTextColumnFilter",
                    type: "numericColumn",
                    cellRenderer: "numberFormatter",
                    aggFunc: "sum"
                }
            ],
            isFullWidthCell: () => false,
            rowSelection: "single",
            rowData: [],
            multiSortKey: "ctrl",
            floatingFilter: true,
            frameworkComponents: {
                numberFormatter: number_formatter_1.NumberFormatter
            }
        };
    }
    async componentDidMount() {
        await store_1.reportsStore.loadClinicReimbursement();
    }
    componentWillUnmount() {
        store_1.reportsStore.clinicReimbData = null;
    }
    render() {
        const storeData = store_1.reportsStore.clinicReimbData;
        this.storeData.rowData = storeData;
        const loadingData = store_1.reportsStore.showLoader;
        if (storeData && storeData.length > 0) {
            return (React.createElement(React.Fragment, null,
                React.createElement(clinic_reimbursement_header_1.ClinicReimbursementHeader, { title: "Pharmacy Reimbursement" }),
                React.createElement("div", { className: "ag-theme-balham", style: {
                        height: "85%",
                        width: "100%"
                    } },
                    React.createElement("button", { type: "button", onClick: this.onButtonExport.bind(this) }, "Export to CSV"),
                    React.createElement(ag_grid_react_1.AgGridReact, { onGridReady: params => {
                            this.storeData.gridApi = params.api;
                            return this.storeData.gridApi;
                        }, rowSelection: this.storeData.rowSelection, columnDefs: this.storeData.columnDefs, defaultColDef: this.storeData.defaultColDef, frameworkComponents: this.storeData.frameworkComponents, multiSortKey: this.storeData.multiSortKey, animateRows: true, 
                        /* this is where we enable the sidebar with pivoting and filtering */
                        // sideBar={true}
                        // groupMultiAutoColumn={true}
                        floatingFilter: this.storeData.floatingFilter, suppressExcelExport: true, 
                        // keep columns visible functionality
                        suppressDragLeaveHidesColumns: true, suppressMakeColumnVisibleAfterUnGroup: true, isFullWidthCell: this.storeData.isFullWidthCell, rowData: this.storeData.rowData }))));
        }
        if (storeData) {
            if (loadingData) {
                return (React.createElement(React.Fragment, null,
                    React.createElement(clinic_reimbursement_header_1.ClinicReimbursementHeader, { title: "Pharmacy Reimbursement" }),
                    React.createElement("div", null, "Loading Data...")));
            }
            // Return a Custom built component here to handle 0 data returned.
            return (React.createElement(no_data_found_1.default, { headerComponent: React.createElement(clinic_reimbursement_header_1.ClinicReimbursementHeader, { title: "Pharmacy Reimbursement" }) }));
        }
        return React.createElement(ui_1.UiLoadingIndicator, null);
    }
};
ClinicReimbursement = __decorate([
    mobx_react_1.observer
], ClinicReimbursement);
exports.ClinicReimbursement = ClinicReimbursement;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/clinic-reimbursement/clinic-reimbursement.tsx
// module id = 3886
// module chunks = 0